import React from 'react';
import { Box, HStack, Text, VStack } from '@chakra-ui/react';
import { ListingCard } from './AiListingCards';

// Renders a round-trip plan as two stacked groups: outbound and return leg.
// Each group shows a labelled header and a list of listings the partner can
// act on (view, submit quote). Empty groups show a guidance hint instead of
// hiding — partners need to see "no return cargo yet" to decide next steps.
function LegGroup({ title, leg, accentColor, navigate, onTriggerMessage, role }) {
  const listings = leg?.listings || [];
  const total = leg?.total ?? listings.length;
  return (
    <VStack align="stretch" spacing={2}>
      <HStack justify="space-between">
        <Text
          fontSize="10px"
          fontWeight="700"
          textTransform="uppercase"
          letterSpacing="0.15em"
          color={accentColor}
        >
          {title}
        </Text>
        <Text fontSize="10px" color="gray.500">
          {leg?.fromLabel || '?'} → {leg?.toLabel || '?'} · {total} match{total === 1 ? '' : 'es'}
        </Text>
      </HStack>
      {listings.length === 0 ? (
        <Box
          borderWidth="1px"
          borderStyle="dashed"
          borderRadius="lg"
          borderColor="gray.300"
          bg="gray.50"
          p={3}
        >
          <Text fontSize="xs" color="gray.500">
            No listings yet for this leg. Try widening the radius or adjusting the date window.
          </Text>
        </Box>
      ) : (
        listings.map((listing) => (
          <ListingCard
            key={listing.id || listing._id}
            listing={listing}
            role={role}
            navigate={navigate}
            onTriggerMessage={onTriggerMessage}
          />
        ))
      )}
    </VStack>
  );
}

export default function AiMultiLegRouteCards({ result, role, navigate, onTriggerMessage }) {
  if (!result) return null;
  return (
    <VStack align="stretch" spacing={4}>
      <LegGroup
        title="Outbound leg"
        leg={result.outbound}
        accentColor="blue.500"
        role={role}
        navigate={navigate}
        onTriggerMessage={onTriggerMessage}
      />
      <LegGroup
        title="Return leg (backhaul)"
        leg={result.returnLeg}
        accentColor="purple.500"
        role={role}
        navigate={navigate}
        onTriggerMessage={onTriggerMessage}
      />
    </VStack>
  );
}
